//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moveLeft from '~/assets/icons/ico-move-left.svg'
import moveRight from '~/assets/icons/ico-move-right.svg'
import ArrowRight from '~/assets/icons/ico-arrow-right.svg'
export default {
  name: 'Scroller',
  components: {
    moveLeft,
    moveRight,
    ArrowRight
  },
  props: {
    slide: {
      type: Number,
      default: 2
    },
    buttons: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    doSlide (direction) {
      const delta = this.$refs.container.getElementsByClassName('scroll-item')[0].scrollWidth * this.slide
      const scroll = {
        left: delta,
        behavior: 'smooth'
      }
      if (direction === 'left') {
        scroll.left = delta * -1
      }
      this.$refs.scroller.scrollBy(scroll)
    }
  }
}
